import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

import { UserService } from '../../../../core/services/user.service';
import { EarlyPayCalculatorComponent } from '../early-pay-calculator/early-pay-calculator.component';

@Component({
  selector: 'app-early-pay-calculator-page',
  templateUrl: './early-pay-calculator-page.component.html',
  styleUrls: ['./early-pay-calculator-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButtonModule, RouterLink, MatIconModule, EarlyPayCalculatorComponent],
})
export class EarlyPayCalculatorPageComponent implements OnInit {
  private userService = inject(UserService);

  isSc = false;

  ngOnInit(): void {
    this.isSc = this.userService.isUserCompanySc();
  }
}
